import { render, staticRenderFns } from "./DevLocalizationKey.vue?vue&type=template&id=337f3d4b&"
import script from "./DevLocalizationKey.vue?vue&type=script&lang=js&"
export * from "./DevLocalizationKey.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports